<template>
    <c-dialog ref="dialog" enable-flex width="450" height="350" @resolve="editHandle">
        <c-form ref="form" vertical unit-width="100%">
            <c-form-item label="自定义编码" required tip="长度必须4位，只能输入数字或英文字母">
                <c-input name="custom_code" maxlength="4" v-model="customCode" placeholder="请输入自定义编码"></c-input>
            </c-form-item>
            <c-form-item label="采集数量" required  tip="单个自定义编码单日采集上限为999个条码">
                <c-input name="unique_code_count" type="stepper" step-controls="side" range="1,999"
                         append-text="个" v-model="unique_code_count" :clear="false"></c-input>
            </c-form-item>
            <div class="preview flex-center">
                <label>预览</label>
                <p>{{ codePreview }}</p>
            </div>
        </c-form>
    </c-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
    components: {},

    data() {
        return {
            customCode: '',
            unique_code_count: 1 //单次采集背贴码数量
        }
    },
    computed: {
        ...mapState(['saasInfo']),

        codePreview() {
            let arr = [];
            //拼接商户code
            if (this.saasInfo.saas_brief_code) {
                arr.push(this.saasInfo.saas_brief_code.toUpperCase().trim());
            }
            //拼接自定义code
            if (this.customCode) {
                arr.push(this.customCode.toUpperCase().trim());
            }else {
                arr.push('XXX');
            }
            //拼接日期
            arr.push(new Date().format('YMMDD'.replace(/Y/g, 'y').replace(/D/g, 'd')));
            //拼接3位后缀
            if (this.unique_code_count) {
                arr.push(this.unique_code_count.toString().padStart(3, '0'));
            }else {
                arr.push('XXX');
            }
            return arr.join('');
        }
    },

    methods: {
        /*********打开编辑框，初始化**********/
        open() {
            this.$refs.form.clear();
            //填充form表单
            this.$refs.dialog.open({
                title: '批量采集背贴码'
            });
        },

        /*******创建、编辑提交处理方法********/
        editHandle(stop, next) {
            stop();
            this.$refs.form.submit({
                url: '/product/unique_code/create',
                rule: {
                    custom_code: [{
                        type: 'empty',
                        message: '请输入4位自定义编码'
                    }, {
                        type: 'function',
                        fun: (value, data) => {
                            return value.trim().length == 4
                        },
                        message: '自定义编码必须输入4个字符'
                    }, {
                        type: 'function',
                        fun: (value, data) => {
                            const reg = /^[A-Za-z0-9]+$/
                            return reg.test(value)
                        },
                        message: '自定义编码只允许输入数字或英文字母'
                    }],
                    unique_code_count: [{
                        type: 'empty',
                        message: '请填写背贴码采集数量'
                    }, {
                        type: 'function',
                        fun: (value, data) => {
                            return value <= 999
                        },
                        message: '单次采集最多采集999个背贴码'
                    }],
                },
                dataFormatter: data => {
                    return data;
                },
                success: (data, res) => {
                    next();
                    if (this.editState) {//编辑
                        this.$message({
                            message: '采集成功',  // 提示内容,
                            type: 'success'
                        });
                    } else {//新增
                        this.$confirm({
                            type: 'success',
                            message: res,
                            buttonName: '知道了',
                            cancelButton: false,
                            resolve: () => {
                            }
                        });

                    }
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.preview {
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    border: 1px solid var(--unit-border);
    padding: 0 20px;
    overflow: hidden;
    background: #FAFAFA;

    p {
        margin-left: 10px;
        font-size: 24px;
    }
}
</style>